import { html } from 'lit';
const BaseballPanel =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.148 6.545A7.97 7.97 0 0 0 4 12c0 2.108.816 4.026 2.148 5.455C6.9 15.927 7.35 14.047 7.35 12S6.9 8.073 6.148 6.545m.998 11.814A7.97 7.97 0 0 0 12 20a7.97 7.97 0 0 0 4.854-1.64c-.95-1.784-1.504-3.989-1.504-6.36s.553-4.576 1.504-6.36A7.97 7.97 0 0 0 12 4a7.97 7.97 0 0 0-4.854 1.64C8.096 7.425 8.65 9.63 8.65 12s-.553 4.576-1.504 6.36M16.65 12c0 2.047.45 3.927 1.202 5.455A7.97 7.97 0 0 0 20 12a7.97 7.97 0 0 0-2.148-5.455C17.1 8.073 16.65 9.953 16.65 12" clip-rule="evenodd"/>
  </svg>
`;
export default BaseballPanel;
